(() => {
  if (window.vrRecentSearchesReady) return;
  window.vrRecentSearchesReady = true;
  const init = () => {
    const lang = document.documentElement.lang.slice(0, 2);
    const copy = lang === 'en' ? ['RECENT SEARCHES', 'Your recent searches will appear here.', 'Clear'] : lang === 'fr' ? ['RECHERCHES RÉCENTES', 'Vos recherches récentes apparaîtront ici.', 'Effacer'] : ['RICERCHE RECENTI', 'Le tue ricerche recenti appariranno qui.', 'Cancella'];
    const key = 'vr_recent_searches_v1';
    const read = () => { try { const list = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(list) ? list.filter(s => typeof s === 'string' && s.length <= 120).slice(0, 8) : []; } catch { return []; } };
    const save = q => { if(q==='*')return; try { localStorage.setItem(key, JSON.stringify([q, ...read().filter(s => s.toLocaleLowerCase() !== q.toLocaleLowerCase())].slice(0, 8))); } catch {} };
    document.querySelectorAll('.vr-hero-search, .vr-mobile-catalog-search form, .vr-catalog-search').forEach((form, i) => {
      const input = form.querySelector('input[name="q"]');
      const submit = form.querySelector('button[type="submit"]');
      if (!input || !submit) return;
      const panel = document.createElement('section');
      panel.className = 'vr-recent-searches';
      panel.id = `vr-recent-searches-${i}`;
      panel.hidden = true;
      panel.setAttribute('aria-label', copy[0]);
      document.body.append(panel);
      input.autocomplete = 'off';
      const predictiveControls = input.getAttribute('aria-controls');
      input.setAttribute('aria-controls', panel.id);
      input.setAttribute('aria-expanded', 'false');
      const originalControls = predictiveControls;
      const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); if (originalControls) input.setAttribute('aria-controls', originalControls); };
      const place = () => {
        const rect = form.getBoundingClientRect();
        if (!rect.width || rect.bottom < 0 || rect.top > window.innerHeight) return close();
        panel.style.left = `${Math.max(8, rect.left)}px`;
        panel.style.width = `${Math.min(rect.width, window.innerWidth - 16)}px`;
        const below = window.innerHeight - rect.bottom - 16;
        const above = below < 170 && rect.top > below;
        panel.style.top = above ? 'auto' : `${rect.bottom + 8}px`;
        panel.style.bottom = above ? `${window.innerHeight - rect.top + 8}px` : 'auto';
        panel.style.maxHeight = `${Math.max(100, Math.min(340, above ? rect.top - 16 : below))}px`;
      };
      const open = () => {
        if (input.value.trim()) return close();
        panel.replaceChildren();
        const heading = document.createElement('div');
        heading.className = 'vr-recent-searches-heading';
        const title = document.createElement('strong');
        title.textContent = copy[0];
        heading.append(title);
        const list = read();
        if (list.length) {
          const clear = document.createElement('button');
          clear.type = 'button'; clear.textContent = copy[2];
          clear.addEventListener('click', () => { try { localStorage.removeItem(key); } catch {} open(); input.focus(); });
          heading.append(clear);
        }
        panel.append(heading);
        if (!list.length) { const empty = document.createElement('p'); empty.textContent = copy[1]; panel.append(empty); }
        list.forEach(q => {
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'vr-recent-search-choice';
          choice.textContent = q;
          choice.addEventListener('click', () => {
            input.value = q;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            close();
            input.focus();
            input.setSelectionRange(q.length, q.length);
          });
          panel.append(choice);
        });
        panel.hidden = false;
        input.setAttribute('aria-controls', panel.id);
        input.setAttribute('aria-expanded', 'true');
        place();
      };
      input.addEventListener('focus', open);
      input.addEventListener('click', () => { if (panel.hidden) open(); });
      input.addEventListener('input', () => input.value.trim() ? close() : open());
      submit.addEventListener('click', event => { if (!input.value.trim()) { event.preventDefault(); input.focus(); open(); } });
      form.addEventListener('submit', event => { const q = input.value.trim().slice(0, 120); if (!q) { event.preventDefault(); open(); } else save(q); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target) && !panel.contains(event.target)) close(); });
      document.addEventListener('focusin', event => { if (!form.contains(event.target) && !panel.contains(event.target)) close(); });
      document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
      window.addEventListener('resize', () => { if (!panel.hidden) place(); });
      window.addEventListener('scroll', () => { if (!panel.hidden) place(); }, { passive: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
